<template>
  <el-tabs v-model="activeName" type="border-card">
    <el-tab-pane label="清单列表" name="first">
      <div class="main">
        <!-- Right -->
        <div class="main_r">
          <!-- search -->
          <div class="search">
            <div>
              <el-select v-model="gvtype" placeholder="字典分类">
                <el-option v-for="item in gvTypeList" :label="item" :value="item"></el-option>
              </el-select>
              <el-input v-model="name"  placeholder="请输入字典名称"></el-input>
              <el-input v-model="gv"  placeholder="请输入字典数据"></el-input>
              <el-button type="primary" @click="clickQuery">查询</el-button>
              <el-button type="primary" @click="clickQueryReset" plain>重置</el-button>
            </div>
          </div>
          <!-- search End -->

          <!-- 列表 -->
          <el-table :data="dataList" ref="projecttable" style="width: 100%" class="tableOut" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="id" label="序号" width="80"></el-table-column>
            <el-table-column prop="type" label="字典分类" width="150"></el-table-column>
            <el-table-column prop="name" label="字典名称" width="150"></el-table-column>
            <el-table-column prop="gv" label="字典数据主"></el-table-column>
            <el-table-column prop="gv2" label="字典数据副"></el-table-column>
            <el-table-column prop="note" label="字典备注"></el-table-column>
            <el-table-column prop="Operation" label="操作" width="100">
              <template v-slot="scope">
                <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-edit" class="mr12" @click="clickEdit(scope.row)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="编辑富文本" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-info" class="mr12" @click="clickUeditor(scope.row)"></el-link>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页 -->
          <div class="mt20">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="pageSize"
              layout="prev, pager, next, sizes, jumper "
              :total="dataListnum">
            </el-pagination>
          </div>
          <!-- 分页 End -->
        </div>
        <!-- Right End -->

        <!---------------------- 以下是一级Table弹框内容 ---------------------->
        <!-- 编辑信息 -->
        <el-dialog title="编辑信息" :visible.sync="dialogEdit" class="newAdd">
          <el-row :gutter="24" class="add_project">
            <!-- left -->
            <el-col :xl="9">
              <el-form :model="editForm">
                <el-form-item label="字典分类" :label-width="formLabelWidth" :required=true>
                  <el-input v-model="editForm.type" autocomplete="off" placeholder="请输入字典分类"></el-input>
                </el-form-item>
                <el-form-item label="字典名称" :label-width="formLabelWidth" :required=true>
                  <el-input v-model="editForm.name" autocomplete="off" placeholder="请输入字典名称"></el-input>
                </el-form-item>
                <el-form-item label="字典数据主" :label-width="formLabelWidth">
                  <el-input v-model="editForm.gv" autocomplete="off" placeholder="请输入字典数据主"></el-input>
                </el-form-item>
                <el-form-item label="字典数据副" :label-width="formLabelWidth">
                  <el-input v-model="editForm.gv2" autocomplete="off" placeholder="请输入字典数据副"></el-input>
                </el-form-item>
                <el-form-item label="字典备注" :label-width="formLabelWidth">
                  <el-input type="textarea" v-model="editForm.note" autocomplete="off" placeholder="请输入字典备注"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="GvUpdate(1)" >确 认</el-button>
            <el-button @click="dialogEdit = false">取 消</el-button>
          </div>
        </el-dialog>
        <!-- 编辑信息 End -->

      </div>
    </el-tab-pane>

    <el-tab-pane label="编辑富文本" name="second" disabled="disabled">
      <VueUeditorWrap v-model="ueditorContent" :config="myConfig"></VueUeditorWrap>
      <el-button type="primary" @click="GvUpdate(2)" >保 存</el-button>
      <el-button @click="GoBack()">返 回</el-button>
    </el-tab-pane>

  </el-tabs>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    VueUeditorWrap
  },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      selectParentId: '',
      gvTypeList: [],
      gvtype: '固件更新',
      name: '',
      gv: '',
      dataList: [],
      dataListnum: 0,
      pageNo: 1,
      pageSize: 5,
      editForm: {
        id: '',
        type: '',
        name: '',
        gv: '',
        gv2: '',
        note: ''
      },
      ueditorContent:'',
      myConfig: {
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 500,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口
        serverUrl: '',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
      },
      currentPage: 0,
      dialogEdit: false
    }
  },
  mounted () {
    console.log(localStorage.getItem('gvTypeList'))
    this.gvTypeList = localStorage.getItem('gvTypeList').split(",");
    console.log(this.gvTypeList)
    this.GvList()
    this.GvNum()
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.GvList()
      this.GvNum()
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.GvList()
      this.GvNum()
    },
    clickQuery () {
      this.GvList()
      this.GvNum()
    },
    clickQueryReset () {
      this.name = ''
      this.gv = ''
      this.GvList()
      this.GvNum()
    },
    clickEdit (row) {
      this.dialogEdit = true
      this.editForm.id = row.id
      this.editForm.type = row.type
      this.editForm.name = row.name
      this.editForm.gv = row.gv
      this.editForm.gv2 = row.gv2
      this.editForm.note = row.note
    },
    clickUeditor(row){
      this.activeName = 'second'
      this.editForm.id = row.id
      this.editForm.type = row.type
      this.editForm.name = row.name
      this.editForm.gv = row.gv
      this.editForm.gv2 = row.gv2
      this.editForm.note = row.note
      this.ueditorContent = row.gv
    },
    GoBack(){
      this.activeName = 'first'
    },
    GvList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.parentId = that.selectParentId
      data.type = that.gvtype
      data.name = that.name
      data.gv = that.gv
      data.pageNo = that.pageNo
      data.pageSize = that.pageSize
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_GvList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    GvNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.parentId = that.selectParentId
      data.type = that.gvtype
      data.name = that.name
      data.gv = that.gv
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_GvNum, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    GvUpdate: function (pType) {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editForm.id
      data.type = that.editForm.type
      data.name = that.editForm.name
      data.gv = that.editForm.gv
      if(pType == 2){
        data.gv = that.ueditorContent
      }
      data.gv2 = that.editForm.gv2
      data.note = that.editForm.note
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_GvUpdate, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindAllways(response.data.msg)
          if (response.data.code === 1) {
            that.dialogEdit = false
            that.GvList()
            that.GvNum()
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.main .main_l{
  width: 380px;
  flex-shrink: 0;
  border-right: 1px solid #e6e6e6;
}
.search {
  margin-top: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .el-input {
    width: 300px;
    margin-right: 15px;
  }

  .el-select{
    margin-right: 15px;
  }

}

@media ( max-width: 1440px) {
  .search {
    margin-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .el-input {
      width: 200px;
      margin-right: 15px;
    }

    .el-select{
      margin-right: 15px;
      width: 110px;
    }
  }
}

// 表格头部背景色
/deep/ .el-table thead {
  color: #373735;
  font-weight: 500;
}

/deep/ .el-table th, .el-table tr {
  background: #eff3ff;
}

/deep/ .el-table__expand-icon {
  display: none;
}

.el-form-item {
  margin-bottom: 16px;
}

.organization_code{
  width: 127px;
  margin-right: 12px;
}

// 新增组织架构
.add_organization{
  padding-right: 15px;

  .organization_code{
    width: 157px;
    margin-right: 12px;
  }
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;

      & em{
        font-style: normal;
        color: #4976ff;
      }
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.sgdInfo{
  padding-left: 20px;
}

.tableOut{
  margin-top: 15px;

  // 圆角处理
  /deep/ thead tr th:nth-child(1) {
    border-radius: 10px 0 0 0;
  }
  /deep/ thead tr th:nth-last-child(2) {
    border-radius: 0 10px 0 0;
  }
}

// 内表格
.tableInner{
  margin-top: 20px;

  ::-webkit-scrollbar{
    width: 6px;  /*滚动条宽度*/
    height: 6px;  /*滚动条高度*/
  }

  /*定义滑块 内阴影+圆角*/
  ::-webkit-scrollbar-thumb{
    border-radius: 3px;
    background-color: #4976ff;  /*滚动条的背景颜色*/
  }

  // 圆角处理
  /deep/ thead tr th:nth-child(1) {
    border-radius: 10px 0 0 0;
  }
  /deep/ thead tr th:last-child {
    border-radius: 0 10px 0 0;
  }
}

.addUser_body{
  padding: 15px 40px 0 30px;
}

/deep/ .el-table__expanded-cell {
  padding: 20px 0px 0px 0px;
  margin: 15px;
  border: 1px solid #4976ff;
  border-radius: 10px;
  overflow: hidden;
}

.position{
  overflow: hidden;
  height: 433px;
  background: #f7f7f7;
}

// 弹出框
/deep/ .el-dialog__body {
  padding: 20px;
}

.newAdd /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  background: #f6f6fa;
}

.confirmDel /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.confirmDel /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.confirmDel /deep/ .el-dialog__headerbtn {
  top: 20px;
}

.confirmMsg{
  padding: 10px 0 10px 0;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;

  & em{
    font-style: normal;
    margin-right: 10px;
    padding: 2px 6px;
    background: #f6f6fa;
    border-radius: 4px;
  }
}

.tree_txt{
  padding: 2px 6px;
  margin-right: 10px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
}

.tree_btn{
  margin-right: 5px;
}

.blue{
  color: #4976ff;
}

/deep/ .el-tree-node__content {
  height: 36px;
}

/deep/ .el-button--primary {
  color: #FFF;
  background-color: #4976ff;
  border-color: #4976ff;
}

/deep/ .el-button--primary.is-plain {
  color: #4976ff;
  background: #eff3ff;
  border-color: #4976ff;
}
/deep/ .el-tree-node__expand-icon {
    color: #4976ff;
  }
/deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  color: #4976ff;
  background-color: #fff;
}
/deep/ .el-tree-node__content:hover {
  color: #4976ff;
  background-color: #fff;
}

// /deep/ .custom-tree-node {
//   padding-right: 0px;
// }

// 组织架构
/deep/ .custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-right: 8px;
}

.tree_add_btn{
  margin-right: 5px;
}
</style>
